// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Typography,
//   Box,
//   Paper,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// export default function SignupPage() {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const validatePassword = (password) => {
//   const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//   return regex.test(password);
// };

// const handleSignup = async (e) => {
//   e.preventDefault();
//   const { name, email, phone, password } = form;

//   if (!name || !email || !phone || !password) {
//     setError("Please fill in all fields.");
//     return;
//   }

//   if (!validatePassword(password)) {
//     setError(
//       "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
//     );
//     return;
//   }

//   try {

//  const res = await fetch("https://yovho-back.vercel.app/logIn-send-account-creation", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(form),
//     });
//  const data = await res.json();
//     console.log("Signup success:", data.Code);
//     toast.success("Account created successfully!");
//   } catch (err) {
//     console.error("Signup failed:", err);
//     setError("Signup failed. Please try again.");
//   } 
//   finally {
//     setLoading(false);
//   }


  
// };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         bgcolor: "#f3f4f6",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         p: 2,
//       }}
//     >
//       <Paper elevation={4} sx={{ p: 4, maxWidth: 400, width: "100%" }}>
//         <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
//           Create an Account
//         </Typography>

//         {error && (
//           <Typography color="error" align="center" sx={{ mb: 2 }}>
//             {error}
//           </Typography>
//         )}

//         <form onSubmit={handleSignup}>
//           <TextField
//             label="Full Name"
//             name="name"
//             fullWidth
//             value={form.name}
//             onChange={handleChange}
//             margin="normal"
//           />
//           <TextField
//             label="Email"
//             name="email"
//             type="email"
//             fullWidth
//             value={form.email}
//             onChange={handleChange}
//             margin="normal"
//           />
//           <TextField
//             label="Phone Number"
//             name="phone"
//             type="tel"
//             fullWidth
//             value={form.phone}
//             onChange={handleChange}
//             margin="normal"
//             inputProps={{ maxLength: 15 }}
//           />
//           <TextField
//             label="Password"
//             name="password"
//             fullWidth
//             type={showPassword ? "text" : "password"}
//             value={form.password}
//             onChange={handleChange}
//             margin="normal"
//             InputProps={{
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
//                     {showPassword ? <VisibilityOff /> : <Visibility />}
//                   </IconButton>
//                 </InputAdornment>
//               ),
//             }}
//           />

//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             sx={{ mt: 2 }}
//             disabled={loading}
//           >
//             {loading ? "Signing up..." : "Sign Up"}
//           </Button>
//         </form>

//         <Typography variant="body2" align="center" sx={{ mt: 2 }}>
//           By signing up, you agree to our{" "}
//           <a href="/terms" style={{ color: "#1976d2" }}>Terms & conditions</a> and{" "}
//           <a href="/privacy" style={{ color: "#1976d2" }}>Privacy Policy</a>.
//         </Typography>
//       </Paper>
//     </Box>
//   );
// }














































// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Typography,
//   Box,
//   Paper,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";

// export default function SignupPage() {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     password: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [step, setStep] = useState("signup"); // "signup" or "verify"
//   const [Code, setCode] = useState(0); // "signup" or "verify"
//   const [verificationCode, setVerificationCode] = useState("");

//   // ✅ Handle form input change
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   // ✅ Validate password format
//   const validatePassword = (password) => {
//     const regex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     return regex.test(password);
//   };

//   // ✅ Handle form submit (signup step)
//   const handleSignup = async (e) => {
//     e.preventDefault();
//     const { name, email, phone, password } = form;

//     if (!name || !email || !phone || !password) {
//       setError("Please fill in all fields.");
//       return;
//     }

//     if (!validatePassword(password)) {
//       setError(
//         "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
//       );
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");
//       setStep("verify")
//       // ✅ Send signup request to your backend API
//       const res = await fetch(
//         "https://yovho-back.vercel.app/logIn-send-account-creation",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(form),
//         }
//       );

//       const data = await res.json();
//       console.log("Signup response:", data);
//       setCode(data.Ma)
//       // ✅ If success, go to verification step
//       if (data?.Ma) {
//         setStep("verify");
//       } else {
//         setError("Something went wrong. Please try again.");
//       }
//     } catch (err) {
//       console.error("Signup failed:", err);
//       setError("Signup failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Handle code verification
//   const handleVerify = async () => {
//     if (!verificationCode) {
//       setError("Please enter the verification code.");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");

//       // const res = await fetch("https://yovho-back.vercel.app/logIn-send-account-creation", {
//       //   method: "POST",
//       //   headers: { "Content-Type": "application/json" },
//       //   body: JSON.stringify({
//       //     email: form.email,
//       //     code: verificationCode,
//       //   }),
//       // });

//       // const data = await res.json();
//       console.log(verificationCode == Code);

//       if (verificationCode == Code) {

//           const { name, email, phone, password } = form;


// const res1 = await fetch("https://yovho-back.vercel.app/user-new-create", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//                  body: JSON.stringify(form),

//       });
//       const data1 = await res1.json();

//       if (!data1.Error) {
//         toast.success("Account created successfully!");
//         localStorage.setItem("User Data",JSON.stringify({data1}))
//         // ✅ Optionally redirect or reset form
//       } else {
//         setError("Invalid verification code.");
//       }
//       }
//     } catch (err) {
//       console.error("Verification failed:", err);
//       setError("Verification failed. Please try again.");
//       setLoading(false);
//       setStep("signup");

//     } 

//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         bgcolor: "#f3f4f6",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         p: 2,
//       }}
//     >
//       <Paper elevation={4} sx={{ p: 4, maxWidth: 400, width: "100%" }}>
//         {/* ✅ SIGNUP STEP */}
//         {step === "signup" && (
//           <>
//             <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
//               Create an Account
//             </Typography>

//             {error && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {error}
//               </Typography>
//             )}

//             <form onSubmit={handleSignup}>
//               <TextField
//                 label="Full Name"
//                 name="name"
//                 fullWidth
//                 value={form.name}
//                 onChange={handleChange}
//                 margin="normal"
//               />
//               <TextField
//                 label="Email"
//                 name="email"
//                 type="email"
//                 fullWidth
//                 value={form.email}
//                 onChange={handleChange}
//                 margin="normal"
//               />
//               <TextField
//                 label="Phone Number"
//                 name="phone"
//                 type="tel"
//                 fullWidth
//                 value={form.phone}
//                 onChange={handleChange}
//                 margin="normal"
//                 inputProps={{ maxLength: 15 }}
//               />
//               <TextField
//                 label="Password"
//                 name="password"
//                 fullWidth
//                 type={showPassword ? "text" : "password"}
//                 value={form.password}
//                 onChange={handleChange}
//                 margin="normal"
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setShowPassword(!showPassword)}
//                         edge="end"
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 fullWidth
//                 sx={{ mt: 2 }}
//                 disabled={loading}
//               >
//                 {loading ? "Signing up..." : "Sign Up"}
//               </Button>
//             </form>

//             <Typography variant="body2" align="center" sx={{ mt: 2 }}>
//               By signing up, you agree to our{" "}
//               <a href="/guest-policy" style={{ color: "#1976d2" }}>
//                 Terms & conditions
//               </a>{" "}
//               and{" "}
//               <a href="/privacy-notice" style={{ color: "#1976d2" }}>
//                 Privacy Policy
//               </a>
//               .
//             </Typography>
//           </>
//         )}

//         {/* ✅ CODE VERIFICATION STEP */}
//         {step === "verify" && (
//           <>
//             <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
//               Verify Your Email
//             </Typography>

//             {error && (
//               <Typography color="error" align="center" sx={{ mb: 2 }}>
//                 {error}
//               </Typography>
//             )}

//             <TextField
//               label="Verification Code"
//               fullWidth
//               value={verificationCode}
//               onChange={(e) => setVerificationCode(e.target.value)}
//               margin="normal"
//             />

//             <Button
//               variant="contained"
//               color="primary"
//               fullWidth
//               sx={{ mt: 2 }}
//               onClick={handleVerify}
//               disabled={loading}
//             >
//               {loading ? "Verifying..." : "Verify & Complete Signup"}
//             </Button>
//           </>
//         )}
//       </Paper>
//     </Box>
//   );
// }
































import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Paper,
} from "@mui/material";
import {  useNavigate } from "react-router-dom";
import { toast } from "react-toastify";


export default function SignupPage() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("signup"); // "signup" or "verify"
  const [Code, setCode] = useState(0);
  const [verificationCode, setVerificationCode] = useState("");

    const navigate = useNavigate();
  
    
  // ✅ Handle input change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Signup step
  const handleSignup = async (e) => {
    e.preventDefault();
    const { fullName, email } = form;

    if (!fullName || !email) {
      setError("Please fill in all fields.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      setStep("verify");

      const res = await fetch(
        "https://striking-dedication-production.up.railway.app/api/v1/user/auth/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const data = await res.json();
      console.log("Signup response:", data);
      setCode(data.data.otp);
      localStorage.setItem("authToken", data.data.otpToken);

      if (data?.data.otpToken) {
        setStep("verify");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Signup failed:", err);
      setError("Signup failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Verify step
  const handleVerify = async () => {
    if (!verificationCode) {
      setError("Please enter the verification code.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      console.log("Verification check:", verificationCode == Code);

      if (verificationCode == Code) {
        const res1 = await fetch("https://striking-dedication-production.up.railway.app/api/v1/user/auth/verify-register-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        });

        const data1 = await res1.json();
        console.log(data1)
        if (!data1.Error) {
          toast.success("Account created successfully!");
          localStorage.setItem("User Data", JSON.stringify(data1.data.user));
          navigate("/");
        } else {
          setError("Invalid verification code.");
        }
      } else {
        setError("Code does not match.");
      }
    } catch (err) {
      console.error("Verification failed:", err);
      setError("Verification failed. Please try again.");
      setStep("signup");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f3f4f6",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      <Paper elevation={4} sx={{ p: 4, maxWidth: 400, width: "100%" }}>
        {/* ✅ SIGNUP STEP */}
        {step === "signup" && (
          <>
            <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
              Create an Account
            </Typography>

            {error && (
              <Typography color="error" align="center" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}

            <form onSubmit={handleSignup}>
              <TextField
                label="Full Name"
                name="fullName"
                fullWidth
                value={form.fullName}
                onChange={handleChange}
                margin="normal"
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                value={form.email}
                onChange={handleChange}
                margin="normal"
              />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
                disabled={loading}
              >
                {loading ? "Signing up..." : "Sign Up"}
              </Button>
            </form>
          </>
        )}

        {/* ✅ VERIFICATION STEP */}
        {step === "verify" && (
          <>
            <Typography variant="h5" gutterBottom align="center" fontWeight="bold">
              Verify Your Email
            </Typography>

            {error && (
              <Typography color="error" align="center" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}

            <TextField
              label="Verification Code"
              fullWidth
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              margin="normal"
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2 }}
              onClick={handleVerify}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Complete Signup"}
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
